define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var user = require('user');
    var _ = require('underscore');
    var scrollManager = require('managers/scroll.manager');
    var MenuView = require('modules/menu/menu.view');
    var BaseView = require('common/base.view');
    var { DateTime } = require('luxon');
    var core = require('core');

    module.exports = MenuView.extend({
        subscribe: function() {
            MenuView.prototype.subscribe.apply(this, arguments);

            if (this.isDesktopMenu() && document.documentElement.classList.contains('root-menu-sticky')) {
                $.event.add(window, 'scroll.menu', this.handleScroll.bind(this));
            }
        },

        handleScroll: function() {
            const hasOverScroll = document.documentElement.scrollTop > 350;
            this.$el.toggleClass('sticky-menu', hasOverScroll);
            this.$el.parent().toggleClass('menu-padding', hasOverScroll);
        },

        _renderSideMenu: function() {
            this.$el.html(
                this.tmpl('side.menu', {
                    menuItems: this.menuItems,
                    isUserLogged: user.isLoggedIn(),
                    userName: user.get('userName'),
                    previousLoginTime:
                        user.get('previousLoginTime') &&
                        DateTime.fromFormat(
                            user.get('previousLoginTime'),
                            'yyyy-LL-dd HH:mm:ss.SSS',
                            { zone: 'utc' }
                        )
                            .toLocal()
                            .toFormat('yyyy-LL-dd HH:mm:ss'),
                }).replace()
            );

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        close: function(callback) {
            if (!this.opened) {
                return;
            }

            scrollManager.enableScrolling(this);
            $(window).off('.menu');

            this.$el.addClass('close');

            this.transitionEnd(this.$('.fn-slide-menu-wrapper'), function() {
                this.$el.removeClass('open close');
                if (_.isFunction(callback)) {
                    callback();
                }
            }, this);

            this.removeOverlay();

            core.trigger('menu:action:leftMenuClosed');

            this.opened = false;
        },

        closeView: function() {
            BaseView.prototype.close.apply(this, arguments);
            this.removeOverlay();
        },
    });
});
